import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Select, message } from 'antd';
import { ChevronLeft } from 'react-feather';

import styles from './stylesAddRulePage.module.css';
import { SIDER_TABS } from '../../../../../utils/Constants';
import { NAVIGATION_ROUTES } from '../../../../../utils/NavigationUtils';
import Layout from '../../../../CommonComponents/Layout/Layout';
import SummaryPanel from '../SummaryPanel/SummaryPanel';
import {
  useWithdrawalReview,
  WithdrawalReviewProvider,
} from '../../WithdrawalReviewContext';

function AddRulePageContent() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { handleCreateRule } = useWithdrawalReview();

  const formValues = Form.useWatch([], form);

  const handleSubmit = async (values) => {
    values = {
      ...values,
      min_transaction_amount: values.min_transaction_amount || 0,
      max_transaction_amount: values.max_transaction_amount || 0,
      num_transactions: values.num_transactions || 0,
    };
    await handleCreateRule(values);
    message.success('Withdrawal Review Rule Added');
    navigate(NAVIGATION_ROUTES.WITHDRAWAL_REVIEW_RULES);
  };

  const handleCancel = () => {
    navigate(NAVIGATION_ROUTES.WITHDRAWAL_REVIEW_RULES);
  };

  return (
    <Layout name={SIDER_TABS.TRANSACTIONS}>
      <div className={styles.container}>
        <div className={styles.header}>
          <button className={styles.backButton} onClick={handleCancel}>
            <ChevronLeft size={20} />
          </button>
          <h1>Creating New Rule</h1>
        </div>

        <div className={styles.content}>
          {/* Left Section - Form */}
          <div className={styles.formSection}>
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              initialValues={{
                name: '',
                min_transaction_amount: '',
                max_transaction_amount: '',
                num_transactions: '',
                period_type: '',
              }}
            >
              {/* Name Section */}
              <div className={styles.section}>
                <div className={styles.formRow}>
                  <div className={styles.formField}>
                    <span>Name</span>
                    <Form.Item
                      name="name"
                      rules={[{ required: true, message: 'Name is required' }]}
                    >
                      <input
                        type="text"
                        className={styles.inputField}
                        placeholder="Enter rule name"
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className={styles.underline}></div>

              {/* Conditions */}
              <div className={styles.section}>
                <h3>Conditions</h3>
                <div className={styles.formRow}>
                  <div className={styles.formField}>
                    <span>Min Transaction Amount</span>
                    <Form.Item name="min_transaction_amount">
                      <input
                        type="number"
                        className={styles.inputField}
                        placeholder="e.g. 10"
                      />
                    </Form.Item>
                  </div>
                  <div className={styles.formField}>
                    <span>Max Transaction Amount</span>
                    <Form.Item name="max_transaction_amount">
                      <input
                        type="number"
                        className={styles.inputField}
                        placeholder="e.g. 500"
                      />
                    </Form.Item>
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formField}>
                    <span>Number of Transactions</span>
                    <Form.Item name="num_transactions">
                      <input
                        type="number"
                        className={styles.inputField}
                        placeholder="e.g. 3"
                      />
                    </Form.Item>
                  </div>
                  <div className={styles.formField}>
                    <span>Period</span>
                    <Form.Item
                      name="period_type"
                      rules={[
                        { required: true, message: 'Period is required' },
                      ]}
                    >
                      <Select
                        className={styles.selectField}
                        placeholder="Select period"
                        options={[
                          {
                            value: 'SINGLE_TRANSACTION',
                            label: 'Single Transaction',
                          },
                          { value: 'HOUR', label: 'Hour' },
                          { value: 'DAY', label: 'Day' },
                          { value: 'WEEK', label: 'Week' },
                          { value: 'MONTH', label: 'Month' },
                          { value: 'YEAR', label: 'Year' },
                          { value: 'ALL_TIME', label: 'All Time' },
                        ]}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className={styles.underline}></div>

              {/* Buttons */}
              <div className={styles.buttonContainer}>
                <button type="submit" className={styles.createButton}>
                  Create
                </button>
              </div>
            </Form>
          </div>

          {/* Right Section - Summary */}
          <div className={styles.summarySection}>
            <SummaryPanel data={formValues} />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default function AddRulePage() {
  return (
    <WithdrawalReviewProvider>
      <AddRulePageContent />
    </WithdrawalReviewProvider>
  );
}
